import type { FC } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import type {
  TSelectValueProps,
} from "@/ui/components/form/Select/Select.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib";

export const SelectValue: FC<TSelectValueProps> = (props) => (
  <span data-component="SelectValue">
    <TextBody
      tag="span"
      size={2}
      isResponsive={false}
      className={cn(
        "block min-w-0 truncate",
        "text-foreground-muted",
      )}
    >
      <SelectPrimitive.Value {...props} />
    </TextBody>
  </span>
);

SelectValue.displayName = SelectPrimitive.Value.displayName;
